import React, { useEffect, useState } from "react";
import firebase from "../config/firebase";
import sportsCommunity from "../assets/img/custom/sportsCommunityBadgeSample.png";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import Paypal from "components/Paypal";
import DownloadBadge from "./DownloadBadge";
import { useDispatch, useSelector } from "react-redux";
import { createSportsCommunityBadge } from "store/actions/SportCommunityBadgeAction";
import { getSportsCommunityBadge } from "store/actions/SportCommunityBadgeAction";
import { getLastSportsCommunityBadge } from "store/actions/SportCommunityBadgeAction";
import Header from "components/Headers/Header";
const SportsCommunityBadge = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { sportsCommunityBadge, lastSportsCommunityBadge } = useSelector(
    (state) => state.sportsCommunityBadge
  );
  const lastBadgeNumber =
    lastSportsCommunityBadge.length > 0
      ? parseInt(lastSportsCommunityBadge[0].badgeNumber.split("-")[1])
      : null;

  const badgeNumber = lastBadgeNumber
    ? `FHP-${lastBadgeNumber + 1}`
    : "FHP-100001";

  const [showPaypal, setShowPaypal] = useState(false);
  const [downloadBadge, setDownloadBadge] = useState(false);
  const [fhpCoinsModal, setFhpCoinsModal] = useState(false);

  const price = sportsCommunityBadge.length > 0 ? 4 : 2;
  const toggleFhpCoinModal = () => {
    setFhpCoinsModal(!fhpCoinsModal);
  };
  const getPaypalDetail = (details) => {
    const payload = {
      amount: details?.purchase_units[0].amount,
      purchaseID: details?.id,
      userID: user?.id,
      badgeType: "Sports Community Badge",
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      badgeNumber: badgeNumber,
    };
    dispatch(createSportsCommunityBadge(payload));
    setShowPaypal(false);
    setDownloadBadge(true);
  };
  useEffect(() => {
    if (user?.id) {
      dispatch(getSportsCommunityBadge(user.id, () => {}));
    }
  }, [user?.id]);
  useEffect(() => {
    dispatch(getLastSportsCommunityBadge(user?.id, () => {}));
  }, []);
  return (
    <>
      <Row className="m-3 mt-5">
        <Col
          md={downloadBadge ? 6 : 12}
          className={`text-center mt-5 ${
            !downloadBadge ? "d-flex justify-content-center" : ""
          }`}
        >
          <div>
            <h1 className="text-center">Sports Community Badge</h1>
            <div className="d-flex justify-content-center">
              <img
                src={sportsCommunity}
                style={{ width: "232px", height: "380px" }}
              />
            </div>
            <div className="d-flex justify-content-center mt-3">
              {showPaypal ? (
                <div className="d-flex justify-content-center mt-3">
                  <Paypal price={price} getPaypalDetail={getPaypalDetail} />
                </div>
              ) : (
                <Button
                  color="primary"
                  className="mx-2"
                  onClick={() => setShowPaypal(true)}
                  disabled={downloadBadge}
                >
                  {`Buy with Paypal ${
                    sportsCommunityBadge.length > 0 ? "$4" : "$2"
                  }`}
                </Button>
              )}
              <Button
                color="primary"
                className="mx-2"
                onClick={toggleFhpCoinModal}
                disabled={downloadBadge}
              >
                {`Buy with ${
                  sportsCommunityBadge.length > 0 ? "2" : "1"
                } FHP Coin`}
              </Button>
            </div>
          </div>
        </Col>

        {downloadBadge && (
          <Col md="6" className="text-center mt-5">
            <DownloadBadge badgeNumber={badgeNumber} />
          </Col>
        )}
      </Row>

      {sportsCommunityBadge.length > 0 && (
        <div className="m-4">
          <h4 className="text-center mb-3">Your Purchased Badges</h4>
          <Table className="text-center table-borderless">
            <thead>
              <tr>
                <th>Badge Number</th>
                <th>Created At</th>
                <th>Price ($)</th>
              </tr>
            </thead>
            <tbody>
              {sportsCommunityBadge.map((badge, index) => (
                <tr key={index}>
                  <td>{badge.badgeNumber}</td>
                  <td>
                    {badge.createdAt?.toDate
                      ? badge.createdAt.toDate().toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "-"}
                  </td>
                  <td>{badge.amount?.value || "-"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      <Modal isOpen={fhpCoinsModal} toggle={toggleFhpCoinModal}>
        <ModalHeader toggle={toggleFhpCoinModal}>Buy with FHP Coin</ModalHeader>
        <ModalBody className="text-center">
          <h3 className="font-weight-500">Coming Soon...</h3>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleFhpCoinModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SportsCommunityBadge;
